import { render, staticRenderFns } from "./LabeledTextWithContext.vue?vue&type=template&id=36833275&scoped=true"
import script from "./LabeledTextWithContext.vue?vue&type=script&lang=ts"
export * from "./LabeledTextWithContext.vue?vue&type=script&lang=ts"
import style0 from "./LabeledTextWithContext.vue?vue&type=style&index=0&id=36833275&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36833275",
  null
  
)

export default component.exports